import axios from 'axios';
import config from 'api/urls-config.json';
import { API } from 'api/constants';

export const getResources = params => {
    return axios.get(`${API + config.pages.resources}`, { params });
};
